import { Ng2OrderModule } from 'ng2-order-pipe';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule , NO_ERRORS_SCHEMA } from '@angular/core';
import { AppComponent } from './app.component';
import { ModalModule, TimepickerModule } from 'ngx-bootstrap';
import {FlexLayoutModule} from "@angular/flex-layout";
import {NgxPaginationModule} from 'ngx-pagination'; 
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {TranslateModule, TranslateStaticLoader, TranslateLoader} from 'ng2-translate/ng2-translate';
import { routes2 } from './dash/dash.router';
import { routes } from './app.router';
import {SoonComponent} from './soon/soon.component';
import { CommunityComponent } from './community/community.component';
import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { SupportComponent } from './support/support.component';
import { HomeComponent } from './home/home.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
/* import { AuthService, AppGlobals } from 'angular2-google-login';
 */import { ReCaptchaModule } from 'angular2-recaptcha';

import {ResponseOptions, Response, Http} from '@angular/http';
import { HttpModule } from '@angular/http';
import { StormpathModule } from 'angular-stormpath';
import { AlertComponent } from './alert.component';
import { AlertService } from './alert.service';
import { NguiPopupModule } from '@ngui/popup';
import {GmapComponent} from './gmap/gmap.component';
import {LoginsucComponent} from './login_sucess/loginsuc.component';
 /* import { AgmCoreModule } from 'angular2-google-maps/core'; */
import { Ng2DropdownModule } from 'ng2-material-dropdown';
import { DashComponent } from './dash/dash.component';
import { Data } from "./data";
import { Ng2CarouselamosModule } from 'ng2-carouselamos';
import { CarouselModule } from 'ngx-bootstrap';
import { ChartsModule } from 'ng2-charts';
import {CountDown} from "ng2-date-countdown";
import { SimpleTimer } from 'ng2-simple-timer';
import { MomentModule } from 'angular2-moment';
// import { AgmCoreModule } from '@agm/core';
/* import {GaugesModule} from 'ng-canvas-gauges/lib'; */



 import { GaugeModule } from 'angular-gauge';
 import { FlashMessagesModule } from 'angular2-flash-messages';
import { FormWizardModule } from 'angular2-wizard';

import {NoopAnimationsModule} from '@angular/platform-browser/animations';
import { AccountComponent } from './account/account.component';
import {ProgressBarModule} from "ng2-progress-bar";
import { DashboardComponent } from './dashboard/dashboard.component';
import { DialogContentExampleDialogComponent } from './dialog-content-example-dialog/dialog-content-example-dialog.component';
import { GatewayComponent } from './gateway/gateway.component';
import { DragulaModule } from 'ng2-dragula';
// import { DatepickerModule } from 'angular2-material-datepicker'
import { ExpansionPanelsModule } from 'ng2-expansion-panels';
import {ResizableModule} from 'angular2-resizable';
import { DetailsComponent } from './details/details.component';
import { RuleComponent } from './rule/rule.component';
// import { ImageUploadModule } from "angular2-image-upload";
import { PasswordStrengthBarModule } from 'ng2-password-strength-bar';
import { ConstComponent } from './const/const.component';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { LocationComponent } from './location/location.component';
import { LocationNewComponent } from './location/new-location/location.component';
import { EditScheComponent } from './edit-sche/edit-sche.component';
import { DatepickerModule, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { AngularDateTimePickerModule  } from 'angular2-datetimepicker';
import {IfScrollbarsModule} from 'ng2-if-scrollbars';

// import { IonicApp, IonicModule } from 'ionic-angular';
import { LoaderServiceComponent } from './loader-service/loader-service.component';
import { GeofencingComponent } from './geofencing/geofencing.component';
import { GeofenceAddComponent } from './geofence-add/geofence-add.component';
import { GeofencingViewComponent } from './geofencing-view/geofencing-view.component';
import { GeofencingView2Component } from './geofencing-view2/geofencing-view2.component';
import { DeviceReportComponent } from './device-report/device-report.component';
import { DeviceEditComponent } from './dashboard/device-edit/device-edit.component';
import { DeviceSpeedReportComponent } from './device-report/device-speed-report/device-speed-report.component';
import { DeviceShareComponent } from './dashboard/device-share/device-share.component';
import { ShareUserComponent } from './dashboard/share-user/share-user.component';
import { DateTimePickerModule  } from 'ng-pick-datetime';
import { SpeednotifyComponent } from './dashboard/speednotify/speednotify.component';
import { ShareLocComponent } from './location/share-loc/share-loc.component';
import { AddComponent } from './add/add.component';
import { ResetpwdComponent } from './resetpwd/resetpwd.component';
import { GetdevdetailComponent } from './const/getdevdetail/getdevdetail.component';
import { IdealReportComponent } from './device-report/ideal-report/ideal-report.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import {DatainjectionService} from './datainjection.service';
import {ContactService} from './contact.service';
import { NotificationComponent } from './notification/notification.component';
import { MyaccountComponent } from './myaccount/myaccount.component';
import { AddCustComponent } from './add-cust/add-cust.component';
import { IgnReportComponent } from './device-report/ign-report/ign-report.component';
import { SpecDevComponent } from './spec-dev/spec-dev.component';
//import {NgxPaginationModule} from 'ngx-pagination'; 
import {Ng2PaginationModule} from 'ng2-pagination';
import { AboutUsComponent } from './about-us/about-us.component';
import { ServicesComponent } from './services/services.component';
import { TripDetailsComponent } from './device-report/trip-details/trip-details.component';
import { SummaryReportComponent } from './device-report/summary-report/summary-report.component';
import {GeofancingReportComponent} from './device-report/geofancing-report/geofancing-report.component';
import { OverSpeedComponent } from './device-report/over-speed/over-speed.component';
import { RouteViolationComponent } from './device-report/route-violation/route-violation.component';
import { StoppageReportComponent } from './device-report/stoppage-report/stoppage-report.component';
import { IgnitionReportComponent } from './device-report/ignition-report/ignition-report.component';
import { DistanceReportComponent } from './device-report/distance-report/distance-report.component';
import { AlertReportComponent } from './device-report/alert-report/alert-report.component';
import { TripReportComponent } from './device-report/trip-report/trip-report.component';
import { GroupComponent } from './group/group.component';
import { AddGroupComponent } from './add-group/add-group.component';
import { DialogDemoComponent } from './dialog-demo/dialog-demo.component';
import { EditGroupComponent } from './edit-group/edit-group.component';
import { DeleteGroupComponent } from './delete-group/delete-group.component';

import { SidemenuFuelComponent } from './sidemenu-fuel/sidemenu-fuel.component';
import { VehicleRouteComponent } from './vehicle-route/vehicle-route.component';
import { RouteSetComponent } from './route-set/route-set.component';
import { ShowRouteComponent } from './show-route/show-route.component';
import { DealersInfoComponent } from './dealers-info/dealers-info.component';
import { RouteMappingComponent } from './route-mapping/route-mapping.component';
import { RouteMapAddComponent } from './route-map-add/route-map-add.component';
import { PointOfIntrestComponent } from './point-of-intrest/point-of-intrest.component';
import { RouteDeleteComponent } from './route-delete/route-delete.component';
import { AddDealerComponent } from './add-dealer/add-dealer.component';
import { NotificationMasterComponent } from './notification-master/notification-master.component';
import { EditCostumerComponent } from './edit-costumer/edit-costumer.component';
import { EditDealerComponent } from './edit-dealer/edit-dealer.component';
import { DriversPerformanceReportComponent } from './device-report/drivers-performance-report/drivers-performance-report.component';
import { TripHistoryComponent } from './trip-history/trip-history.component';
import { PoiListComponent } from './poi-list/poi-list.component';

import { ShowCaliberationComponent} from './show-caliberation/show-caliberation.component';
import {VehicleTypeComponent} from './vehicle-type/vehicle-type.component';
import { DriverDetailComponent } from './driver-detail/driver-detail.component';
import { DeviceModelComponent } from './device-model/device-model.component';
import { AddEditVehicleTypeComponent } from './add-edit-vehicle-type/add-edit-vehicle-type.component';
import { AddDriverComponent } from  './add-driver/add-driver.component';
import { AddDeviceModelComponent } from './add-device-model/add-device-model.component';
import { MdButtonModule, MdCheckboxModule, MaterialModule,MdAutocompleteModule, MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { EditRouteMapComponent } from './edit-route-map/edit-route-map.component';
import { POIdetailsComponent } from './poidetails/poidetails.component';
import { PoiDtlDelComponent } from './poi-dtl-del/poi-dtl-del.component';
import { AcReportComponent } from './device-report/ac-report/ac-report.component';
import { FuelReportComponent } from './device-report/fuel-report/fuel-report.component';
import { PoiMenuComponent } from './poi-menu/poi-menu.component';
import { AllMenusComponent } from './all-menus/all-menus.component';
import { LoadManagementComponent } from './load-management/load-management.component';
import { FuelReportGraphComponent } from './fuel-report-graph/fuel-report-graph.component';
import { EditVehicleTypeComponent } from './edit-vehicle-type/edit-vehicle-type.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { UserMasterComponent } from './user-master/user-master.component';
import { DeviceComponent } from './device/device.component';
import { GpsMasterComponent } from './gps-master/gps-master.component';
import { CmdPacketMasterComponent } from './cmd-packet-master/cmd-packet-master.component';
import { EditDeviceMasterComponent } from './device/edit-device-master/edit-device-master.component';
import { GpsEditMasterComponent } from './gps-master/gps-edit-master/gps-edit-master.component';
import { POIReportComponent } from './device-report/poi-report/poi-report.component';
import { AddpoiBylocationComponent } from './addpoi-bylocation/addpoi-bylocation.component';
import { POIreportComponent } from './poireport/poireport.component';
import { LRNumberComponent } from './lr-number/lr-number.component';
import { DayWiseReportComponent } from './device-report/day-wise-report/day-wise-report.component';
import { DeviceFuelReportComponent } from './device-report/device-fuel-report/device-fuel-report.component';
import { SOSAlertComponent } from './sosalert/sosalert.component';
import { EditDeviceModelComponent } from './edit-device-model/edit-device-model.component';
import { PoiMasterEditComponent } from './poi-master-edit/poi-master-edit.component';
import { NotificationSettingComponent } from './notification-setting/notification-setting.component';
import { DeviceSOSreportComponent } from './device-report/device-sosreport/device-sosreport.component';
import { SearchFilterPipe } from './search-filter.pipe';
import { LiveHistoryComponent } from './location/live-history/live-history.component';
import { DeviceEntryComponent } from './device-entry/device-entry.component';
import { InventoryListComponent } from './inventory-list/inventory-list.component';
import { AcreportInfoComponent } from './device-report/ac-report/acreport-info/acreport-info.component';
import { GeneralSettingsComponent } from './dashboard/general-settings/general-settings.component';
import { DistributersListComponent } from './distributers-list/distributers-list.component';
import { AddDistributersComponent } from './add-distributers/add-distributers.component';
import { CostumerSupportComponent } from './costumer-support/costumer-support.component';
import { CreateTripComponent } from './location/create-trip/create-trip.component';
import { TripByDeviceComponent } from './device-report/trip-by-device/trip-by-device.component';
import { FuelObjectcomponentComponent } from './fuel-objectcomponent/fuel-objectcomponent.component';
import { TravelPathReportComponent } from './device-report/travel-path-report/travel-path-report.component';
import { ExpenseComponentComponent } from './device-report/trip-by-device/expense-component/expense-component.component';
import { ExpenselistComponent } from './device-report/trip-by-device/expenselist/expenselist.component';
import { ReportSettingComponent } from './add/report-setting/report-setting.component';
import { NormalCertComponent } from './device/normal-cert/normal-cert.component';
import { CertOptionComponent } from './device/cert-option/cert-option.component';
import { IdleReportComponent } from './device-report/idle-report/idle-report.component';
import { VehicleReminderComponent } from './vehicle-reminder/vehicle-reminder.component';

import { AddReminderComponent } from './vehicle-reminder/add-reminder/add-reminder.component';
import { ImmobilizeComponent } from './location/immobilize/immobilize.component';
import { ReportFilterComponent } from './device-report/report-filter/report-filter.component';
import { ResetPasswordComponent } from './add/reset-password/reset-password.component';
import { DealerPermissionComponent } from './dealers-info/dealer-permission/dealer-permission.component';
import { DashboardContentComponent } from './add/dashboard-content/dashboard-content.component';
import { SharedDevicesComponent } from './const/shared-devices/shared-devices.component';
import { DailyLogsComponent } from './device-report/daily-logs/daily-logs.component';
import { VehicleExpensesComponent } from './vehicle-expenses/vehicle-expenses.component';
import { AddVehicleExpensesComponent } from './vehicle-expenses/add-vehicle-expenses/add-vehicle-expenses.component';
import { VehicleExpenseDetailComponent } from './vehicle-expenses/vehicle-expense-detail/vehicle-expense-detail.component';
import { ProductSummaryComponent } from './product-summary/product-summary.component';
import { AddProductComponent } from './product-summary/add-product/add-product.component';
import { ProductShopComponent } from './product-shop/product-shop.component';
import { ProductOverviewComponent } from './product-shop/product-overview/product-overview.component';
import { PointShareComponent } from './point-share/point-share.component';
import { MessageUtilityComponent } from './message-utility/message-utility.component';
import { TripLoadUnloadComponent } from './device-report/trip-load-unload/trip-load-unload.component';
import { BuyNowComponent } from './product-shop/buy-now/buy-now.component';
import { BillingInfoComponent } from './product-shop/billing-info/billing-info.component';
import { OrderSummaryComponent } from './product-shop/order-summary/order-summary.component';
import { OrderDetailsComponent } from './product-shop/order-details/order-details.component';
import { DemoVideosComponent } from './const/demo-videos/demo-videos.component';
import { SafePipe } from './const/safe.pipe';
import { BillingDashboardComponent } from './billing-dashboard/billing-dashboard.component';
import { WorkingHourDetailComponent } from './device-report/working-hour-detail/working-hour-detail.component';
import { WorkingHourReportComponent } from './device-report/working-hour-report/working-hour-report.component';
import { AccountDetailComponent } from './account-detail/account-detail.component';
import { TempretureGraphComponent } from './device-report/tempreture-graph/tempreture-graph.component';
import { CensorDisplayComponent } from './censor-display/censor-display.component';
import { ManualAddressComponent } from './const/manual-address/manual-address.component';
import { AddressUpdateComponent } from './address-update/address-update.component';
import { CmdUIComponent } from './location/cmd-ui/cmd-ui.component';
import { CommanQueueComponent } from './comman-queue/comman-queue.component';
import { CommandWindowComponent } from './location/command-window/command-window.component';
import { AddDeviceComponent } from './location/add-device/add-device.component';
import { MaintananceComponent } from './device-report/maintanance/maintanance.component';
import { SubAminComponent } from './sub-amin/sub-amin.component';
import { AddsubadminComponent } from './sub-amin/addsubadmin/addsubadmin.component';
import { PlayTripComponent } from './play-trip/play-trip.component';
import { TempretureReportComponent } from './device-report/tempreture-report/tempreture-report.component';
import { CommentWindowComponent } from './comment-window/comment-window.component';
import { DetailComponent } from './device-report/distance-report/details/details.component';
import { DailyDetailsComponent } from './device-report/daily-details/daily-details.component';
import { AnnouncementComponent } from './const/announcement/announcement.component';
import { ReportModule } from './report/report.module';
import { ReportService } from './report/report.service';
import { DeviceRenewComponent } from './device-renew/device-renew.component';
import { ReportScheduleComponent } from './report-schedule/report-schedule.component';
import { DeviceListComponent } from './device-list/device-list.component';
import { TollComponent } from './toll/toll.component';
import { RenewalHistoryComponent } from './dashboard/renewal-history/renewal-history.component';
import { DeviceInventoryComponent } from './device-inventory/device-inventory.component';
import { SelectUntrackVehiclesComponent } from './geofencing/select-untrack-vehicles/select-untrack-vehicles.component';
import { IssueListComponent } from './issue-list/issue-list.component';
import { TechnicianComponent } from './technician/technician.component';
import { JobCardComponent } from './job-card/job-card.component';
import { AddJobCardComponent } from './job-card/add-job-card/add-job-card.component';
import { RechargeComponent } from './recharge/recharge.component';
import { AddPlanComponent } from './account-detail/add-plan/add-plan.component';
import { RenewVehicleComponent } from './dashboard/renew-vehicle/renew-vehicle.component';
import { RoutePlanComponent } from './route-plan/route-plan.component';
import { RoutPlanReportComponent } from './rout-plan-report/rout-plan-report.component';
import { ShowPullDataLinkComponent } from './add/show-pull-data-link/show-pull-data-link.component';
import { NewTempReportComponent } from './device-report/tempreture-report/new-temp-report/new-temp-report.component';
import { RouteListComponent } from './route-plan/route-list/route-list.component';
import { HualtListComponent } from './route-plan/hualt-list/hualt-list.component';
import { InactiveAdminComponent } from './inactive-admin/inactive-admin.component';
import { UserFinderComponent } from './user-finder/user-finder.component';
import { ShowVehiclesComponent } from './show-vehicles/show-vehicles.component';
import { ViewCustomerDetailsComponent } from './add/view-customer-details/view-customer-details.component';
import { OtpScreenComponent } from './add/otp-screen/otp-screen.component';
import { KycApprovalComponent } from './kyc-approval/kyc-approval.component';
import { FuelPriceComponent } from './fuel-price/fuel-price.component';
import { AddFuelPriceComponent } from './add-fuel-price/add-fuel-price.component';
import { ShoRoutePlanComponent } from './location/sho-route-plan/sho-route-plan.component';
import { EChalanComponent } from './dashboard/e-chalan/e-chalan.component';
import { TrackedVehiclesComponent } from './vehicle-route/tracked-vehicles/tracked-vehicles.component';
import { RtoMasterComponent } from './rto-master/rto-master.component';
import { OpenMapComponent } from './open-map/open-map.component';
import { MoveMarkerService } from './location/move-marker.service';
import { LocationCommanService } from './location/service/location-comman.service';
// import { DisatanceReportComponent } from './report/disatance-report/disatance-report.component';
// import { MainComponent } from './report/main/main.component';
// import { AcReportsComponent } from './report/ac-report/ac-report.component';











// import { LiveTrackingComponent } from './live-tracking/live-tracking.component';


// import { NgSelectModule } from '@ng-select/ng-select';
// import { EditDeviceMasterComponent } from './device/src/app/device/edit-device-master/edit-device-master.component'; 


// import { NgCircleProgressModule } from 'ng-circle-progress';

// import { NgCircleProgressModule } from 'ng-circle-progress';

/* const googleMapsCore = AgmCoreModule.forRoot({
  apiKey : 'AIzaSyDZKxpYMfGSyStS3fLuVqHuM6ZEJWtF1-k',
}); */

/* const googleMapsCore = AgmCoreModule.forRoot({
  apiKey : 'AIzaSyDZKxpYMfGSyStS3fLuVqHuM6ZEJWtF1-k',
}); */

export function createTranslateLoader(http: Http) {
  return new TranslateStaticLoader(http, './assets/i18n', '.json');
}


@NgModule({
  declarations: [

    AppComponent,
    CommunityComponent,
    LoginComponent,
    SignupComponent,
    CountDown,
    SupportComponent,
    HomeComponent,
    AlertComponent,
    LoginsucComponent,
    GmapComponent,
    DashComponent,
    SoonComponent,
    AccountComponent,
    DashboardComponent,
    DialogContentExampleDialogComponent,
    GatewayComponent,
    DetailComponent,
    RuleComponent,
    ConstComponent,
    LocationComponent,
    LocationNewComponent,
    EditScheComponent,
    LoaderServiceComponent,
    GeofencingComponent,
    GeofenceAddComponent,
    GeofancingReportComponent,
    GeofencingViewComponent,
    GeofencingView2Component,
    DeviceReportComponent,
    DeviceEditComponent,
    DeviceSpeedReportComponent,
    DeviceShareComponent,
    ShareUserComponent,
    SpeednotifyComponent,
    ShareLocComponent,
    AddComponent,
    ResetpwdComponent,
    GetdevdetailComponent,
    IdealReportComponent,
    SidebarComponent,
    NotificationComponent,
    MyaccountComponent,
    AddCustComponent,
    IgnReportComponent,
    SpecDevComponent,
    AboutUsComponent,
    ServicesComponent,
    TripDetailsComponent,
    SummaryReportComponent,
    GeofancingReportComponent,
    OverSpeedComponent,
    RouteViolationComponent,
    StoppageReportComponent,
    IgnitionReportComponent,
    DistanceReportComponent,
    AlertReportComponent,
    TripReportComponent,
    GroupComponent,
    AddGroupComponent,
    DialogDemoComponent,
    EditGroupComponent,
    DeleteGroupComponent,
    AccountDetailComponent,
    SidemenuFuelComponent,
    VehicleRouteComponent,
    RouteSetComponent,
    ShowRouteComponent,
    DealersInfoComponent,
    RouteMappingComponent,
    RouteMapAddComponent,
    PointOfIntrestComponent,
    RouteDeleteComponent,
    AddDealerComponent,
    NotificationMasterComponent,
    EditCostumerComponent,
    EditDealerComponent,
    DriversPerformanceReportComponent,
    TripHistoryComponent,
    PoiListComponent,
    ShowCaliberationComponent,
    VehicleTypeComponent,
    DriverDetailComponent,
    DeviceModelComponent,
    AddEditVehicleTypeComponent,
    AddDriverComponent,
    AddDeviceModelComponent,
    EditRouteMapComponent,
    POIdetailsComponent,
    PoiDtlDelComponent,
    AcReportComponent,
    FuelReportComponent,
    PoiMenuComponent,
    AllMenusComponent,
    LoadManagementComponent,
    FuelReportGraphComponent,
    EditVehicleTypeComponent,
    UserMasterComponent,
    DeviceComponent,
    GpsMasterComponent,
    CmdPacketMasterComponent,
    EditDeviceMasterComponent,
    GpsEditMasterComponent,
    POIReportComponent,
    AddpoiBylocationComponent,
    POIreportComponent,
    LRNumberComponent,
    DayWiseReportComponent,
    DeviceFuelReportComponent,
    SOSAlertComponent,
    EditDeviceModelComponent,
    PoiMasterEditComponent,
    NotificationSettingComponent,
    DeviceSOSreportComponent,
    SearchFilterPipe,
    LiveHistoryComponent,
    DeviceEntryComponent,
    InventoryListComponent,
    AcreportInfoComponent,
    GeneralSettingsComponent,
    DistributersListComponent,
    AddDistributersComponent,
    CostumerSupportComponent,
    CreateTripComponent,
    TripByDeviceComponent,
    FuelObjectcomponentComponent,
    TravelPathReportComponent,
    ExpenseComponentComponent,
    ExpenselistComponent,
    ReportSettingComponent,
    NormalCertComponent,
    CertOptionComponent,
    IdleReportComponent,
    VehicleReminderComponent,
    AddReminderComponent,
    ImmobilizeComponent,
    ReportFilterComponent,
    ResetPasswordComponent,
    DealerPermissionComponent,
    DashboardContentComponent,
    SharedDevicesComponent,
    DailyLogsComponent,
    VehicleExpensesComponent,
    AddVehicleExpensesComponent,
    VehicleExpenseDetailComponent,
    ProductSummaryComponent,
    AddProductComponent,
    ProductShopComponent,
    ProductOverviewComponent,
    PointShareComponent,
    MessageUtilityComponent,
    TripLoadUnloadComponent,
    BuyNowComponent,
    BillingInfoComponent,
    OrderSummaryComponent,
    OrderDetailsComponent,
    DemoVideosComponent,
    SafePipe,
    BillingDashboardComponent,
    WorkingHourReportComponent,
    WorkingHourDetailComponent,
    TempretureGraphComponent,
    CensorDisplayComponent,
    ManualAddressComponent,
    AddressUpdateComponent,
    CmdUIComponent,
    CommanQueueComponent,
    CommandWindowComponent,
    AddDeviceComponent,
    MaintananceComponent,
    SubAminComponent,
    AddsubadminComponent,
    PlayTripComponent,
    TempretureReportComponent,
    CommentWindowComponent,
    DailyDetailsComponent,
    DetailsComponent,
    AnnouncementComponent,
    DeviceRenewComponent,
    ReportScheduleComponent,
    DeviceListComponent,
    TollComponent,
    RenewalHistoryComponent,
    DeviceInventoryComponent,
    SelectUntrackVehiclesComponent,
    IssueListComponent,
    TechnicianComponent,
    JobCardComponent,
    AddJobCardComponent,
    RechargeComponent,
    AddPlanComponent,
    RenewVehicleComponent,
    RoutePlanComponent,
    RoutPlanReportComponent,
    ShowPullDataLinkComponent,
    NewTempReportComponent,
    RouteListComponent,
    HualtListComponent,
    InactiveAdminComponent,
    UserFinderComponent,
    ShowVehiclesComponent,
    ViewCustomerDetailsComponent,
    OtpScreenComponent,
    KycApprovalComponent,
    FuelPriceComponent,
    AddFuelPriceComponent,
    ShoRoutePlanComponent,
    EChalanComponent,
    TrackedVehiclesComponent,
    RtoMasterComponent,
    OpenMapComponent,
    // LiveTrackingComponent,
    // MainComponent,
    // DisatanceReportComponent,
    // AcReportsComponent

  ],
  imports: [
    /* 
    AgmCoreModule.forRoot({
      apiKey:  'AIzaSyDZKxpYMfGSyStS3fLuVqHuM6ZEJWtF1-k'
    }), */
    // NgCircleProgressModule.forRoot({
    //   // set defaults here
    //   radius: 100,
    //   outerStrokeWidth: 16,
    //   innerStrokeWidth: 8,
    //   outerStrokeColor: "#78C000",
    //   innerStrokeColor: "#C7E596",
    //   animationDuration: 300,
    
    // }),
    IfScrollbarsModule,
    GaugeModule.forRoot(),
   /*   GaugesModule, */
    DateTimePickerModule ,
    AngularDateTimePickerModule,    
    BrowserModule,
    NgbModule.forRoot(),
    NgxPaginationModule,
    MDBBootstrapModule.forRoot(),
    BsDatepickerModule.forRoot(),
    ExpansionPanelsModule,
    routes2,
    Ng2SearchPipeModule,
    Ng2OrderModule,
    MomentModule,
    PasswordStrengthBarModule,
    DatepickerModule,
    DragulaModule,
    routes,
    ResizableModule,
    ProgressBarModule,
    FlashMessagesModule,
    // NgSelectModule,
    FormsModule, 
    ReactiveFormsModule, 
    ReCaptchaModule, 
    HttpModule,  
    StormpathModule, 
    NguiPopupModule,
   /*  googleMapsCore, */
    Ng2DropdownModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,
    MdButtonModule,
    MdCheckboxModule,
    MdAutocompleteModule,
    ChartsModule,
    FlexLayoutModule,
    MaterialModule,
    TranslateModule.forRoot({
      provide: TranslateLoader,
      useFactory: (createTranslateLoader),
      deps: [Http]
    }),

    FormWizardModule,BrowserModule, ChartsModule,
    Ng2CarouselamosModule,
  //  GaugeModule.forRoot(),
    CarouselModule.forRoot(),
    TimepickerModule.forRoot(),
    BsDatepickerModule.forRoot(),
    ReportModule,
    ModalModule.forRoot()
    
  ],
  schemas: [ NO_ERRORS_SCHEMA ],
  entryComponents:[PoiDtlDelComponent,EditDeviceMasterComponent,AcreportInfoComponent,GpsEditMasterComponent,RenewalHistoryComponent,PoiMenuComponent,ExpenseComponentComponent,
    AddpoiBylocationComponent,CreateTripComponent,CommentWindowComponent,DetailComponent,DailyDetailsComponent,RenewVehicleComponent,ViewCustomerDetailsComponent,OtpScreenComponent,
    AnnouncementComponent,SelectUntrackVehiclesComponent,ExpenselistComponent,AddPlanComponent,AddDriverComponent,ShowPullDataLinkComponent,HualtListComponent,ShoRoutePlanComponent,EChalanComponent,TrackedVehiclesComponent],
    providers: [/* AuthService , */ AlertService, Data, SimpleTimer,DatainjectionService,ContactService,ReportService,MoveMarkerService,LocationCommanService,
   { provide: MD_DIALOG_DATA, useValue: {} },
    { provide: MdDialogRef, useValue: {} }],
    exports: [AllMenusComponent],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(){
    //for raw angular running on 4200
    var a="http://localhost:3005";

    //for built angular served by backend
    //var a="";
  }

 }



// WEBPACK FOOTER //
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/app.module.ts